import React from 'react';
import { Grid } from '@mui/material';
import { refresh } from '../../utils/index';
import NewUserInfo from '../../Main/NewUserInfo';
import styles from '../../Main/main.styles';
import { makeStyles } from 'tss-react/mui';
import EmergencyButton from '../Components/EmergencyButton';
import './CanEmergency.css';
import PhoneInput from '../../components/PhoneInput';
import ReactGoogleAutocomplete from 'react-google-autocomplete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { find, isEmpty } from 'lodash';
import axios from 'axios';
import { toast } from 'react-toastify';
import validations from '../../input-validation.service';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import StripeCardForm from '../../SignUp_Login/StripeCardForm';
import moment from 'moment';
import useStore from '../../Store/Store';
import RecipientsSelector from '../Components/RecipientsSelector';
import Button from '../../components/Button';
import TextInput from '../../components/TextInput';
import SideBar from '../../components/SideBar';
import { useTranslation } from 'react-i18next';
import { useUserLocation } from '../../hooks/useUserLocation';
const useStyles = makeStyles()(styles);
const CanEmergency = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const user = useStore((state) => state.user);
  const selectedRecipient = useStore((state) => state.selectedRecipient);
  const width = useStore((state) => state.screenWidth);
  const { country } = useUserLocation();
  const [state, setState] = React.useState({
    phoneNo: '',
    phoneVerified: false,
    address: null,
    addressError: '',
  });
  const [otpModal, setOtpModal] = React.useState(false);
  const [paymentMoal, setPaymentModal] = React.useState(false);
  const [paymentLoader, setPaymentLoader] = React.useState(false);
  const [paymentError, setPaymentError] = React.useState('');

  const [otp, setOtp] = React.useState('');
  const [otpError, setOtpError] = React.useState('');
  const [emergencySubscription, setEmergencySubscription] = React.useState(null);

  React.useEffect(() => {
    if (!isEmpty(user)) {
      const data = find(user?.stripeInfo?.subscriptions, (i) => i.type === 'EMERGENCY');
      setEmergencySubscription(data);
    }
  }, [user]);

  React.useEffect(() => {
    if (!isEmpty(selectedRecipient)) {
      getCareRecipientDetails();
    } else {
      if (!isEmpty(user)) {
        const data = {
          phoneNo: user?.canCareEmergency?.phoneNo || '',
          phoneVerified: user?.canCareEmergency?.phoneVerified,
          address: !isEmpty(user?.canCareEmergency?.address)
            ? {
                address: user?.canCareEmergency?.address,
                location: user?.canCareEmergency?.location,
              }
            : null,
          addressError: '',
        };
        setState(data);
      }
    }
  }, [user, selectedRecipient]);

  const getCareRecipientDetails = React.useCallback(async () => {
    try {
      let { data } = await axios.get(
        process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${user?._id}/careRecipient/${selectedRecipient}`,
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: localStorage.getItem('auth'),
          },
        },
      );

      data = data?.data || {};

      const response = {
        phoneNo: data?.canCareEmergency?.phoneNo || '',
        phoneVerified: data?.canCareEmergency?.phoneVerified,
        address: !isEmpty(data?.canCareEmergency?.address)
          ? {
              address: data?.canCareEmergency?.address,
              location: data?.canCareEmergency?.location,
            }
          : null,
        addressError: '',
      };
      setState(response);
    } catch (error) {
      console.log(error);
    }
  }, [selectedRecipient]);

  const handleSetAddress = (address) => {
    const { formatted_address, address_components: addressComponent, geometry } = address;
    setState((prev) => {
      return { ...prev, addressError: '', address: null };
    });
    const isValidAddress = addressComponent[0].types.includes('street_number');
    if (isValidAddress) {
      const processedAddressObj = {};
      for (let item of addressComponent) {
        processedAddressObj[item.types[0]] = item.long_name;
      }

      const data = {
        address: formatted_address,
        location: {
          lat: geometry?.location?.lat(),
          lng: geometry?.location?.lng(),
        },
      };
      setState((prev) => {
        return { ...prev, address: data };
      });
    } else {
      setState((prev) => {
        return { ...prev, addressError: t('notResidentialAddress') };
      });
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const userId = user?._id || user?.id;
      const { phoneNo, address } = state;
      if (isEmpty(phoneNo) || isEmpty(address)) {
        setState((prev) => {
          return { ...prev, addressError: t('Fill all the fields') };
        });
        return;
      }
      if (!isEmpty(selectedRecipient)) {
        await axios.post(
          process.env.REACT_APP_EXPRESS_URL +
            `/api/canCare/caregiver/${userId}/updateEmergencyData/${selectedRecipient}`,
          { phoneNo, address },
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      } else {
        await axios.post(
          process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${userId}/updateEmergencyData`,
          { phoneNo, address },
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      }

      await refresh();
      toast.success(t('emergencyDataUpdated'));
    } catch (error) {
      if (error?.response?.status === 400 && !isEmpty(error?.response?.data?.data)) {
        for (let err of error?.response?.data?.data) {
          toast.error(err || t('Something went wrong!'));
        }
      } else {
        setState((prev) => {
          return { ...prev, addressError: t('Something went wrong!') };
        });
      }
    }
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    try {
      const { phoneNo } = state;
      const userId = user?._id || user?.id;
      if (!validations.validatePhoneNumber(phoneNo)) {
        setState((prev) => {
          return { ...prev, addressError: t('enterValidPhoneNumber') };
        });
      }
      if (!isEmpty(selectedRecipient)) {
        await axios.post(
          process.env.REACT_APP_EXPRESS_URL + `/api/canCare/caregiver/${userId}/sendEmergencyOTP/${selectedRecipient}`,
          { phoneNo },
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      } else {
        await axios.post(
          process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${userId}/sendEmergencyOTP`,
          { phoneNo },
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      }

      setOtpModal(true);
    } catch (error) {
      console.log('error =====> ', error);
      toast.error(error.response?.data?.message || t('Something went wrong!'));
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    try {
      const { phoneNo } = state;
      const userId = user?._id || user?.id;
      if (!validations.validatePhoneNumber(phoneNo)) {
        setState((prev) => {
          return { ...prev, addressError: t('enterValidPhoneNumber') };
        });
      }
      if (!isEmpty(selectedRecipient)) {
        await axios.post(
          process.env.REACT_APP_EXPRESS_URL +
            `/api/canCare/caregiver/${userId}/verifyEmergencyOTP/${selectedRecipient}`,
          { otp },
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      } else {
        await axios.post(
          process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${userId}/verifyEmergencyOTP`,
          { otp },
          {
            headers: {
              'Content-Type': 'application/json',
              authorization: localStorage.getItem('auth'),
            },
          },
        );
      }

      setState((prev) => {
        return { ...prev, phoneVerified: true };
      });

      await refresh();
      toast.success(t('phoneVerifiedSuccess'));
      setOtpModal(false);
    } catch (error) {
      console.log('error =====> ', error);
      setOtpError(error.response?.data?.message || t('incorrectOtp'));
    }
  };

  const handleSubmitSubscription = async (token) => {
    setPaymentError('');
    setPaymentLoader(true);
    try {
      const userId = user?._id || user?.id;
      const email = user?.email;

      await axios.post(
        process.env.REACT_APP_EXPRESS_URL + `/api/canCare/user/${userId}/addCard`,
        { email, token },
        {
          headers: {
            'Content-Type': 'application/json',
            authorization: localStorage.getItem('auth'),
          },
        },
      );
      await refresh();
      setPaymentModal(false);
    } catch (error) {
      console.log('error =====> ', error);
      setPaymentError(error.response?.data?.message || 'Incorrect OTP entered!');
    } finally {
      setPaymentLoader(false);
    }
  };

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <div>
          <SideBar />
        </div>

        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
          <NewUserInfo isSideBar={false} />
          <div className="flex-column-a" style={{ left: width > 850 ? '17%' : '0%' }}>
            <RecipientsSelector />
            <Grid container>
              <h2 style={{ textAlign: 'start' }}>{t('canEmergency')}</h2>
              {/* emergency settings tab */}
              <Grid container direction="row" justify="flex-start">
                <Grid className="can-emergency-settings" container xs={12} sm={12} md={8} lg={8}>
                  <h4>{t('canEmergencySettings')}</h4>
                  <Grid container className="can-emergency-phone">
                    <h5>{t('yourEmergencyPhoneNumber')}</h5>
                    <Grid container className="phone-div" direction="row">
                      <Grid container xs={12} sm={12} md={10} lg={10}>
                        <PhoneInput
                          value={state.phoneNo}
                          defaultCountry={country}
                          onChange={(value) =>
                            setState((prev) => {
                              return { ...prev, phoneNo: value, phoneVerified: false };
                            })
                          }
                        />
                      </Grid>
                      <Grid container xs={12} sm={12} md={2} lg={2}>
                        {state?.phoneVerified ? (
                          <div className="verified-div">
                            <CheckCircleIcon style={{ color: '#26786a' }} />{' '}
                            <span style={{ marginLeft: '5px' }}>{t('verified')}</span>
                          </div>
                        ) : (
                          <Button
                            onClick={handleSendOtp}
                            text={t('verify')}
                            style={{ height: '50px', marginLeft: '10px' }}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container className="can-emergency-phone" style={{ marginTop: '40px' }}>
                    <h5>{t('emergencyAddress')}</h5>
                    <Grid container>
                      <ReactGoogleAutocomplete
                        options={{
                          types: ['geocode'],
                          componentRestrictions: { country: 'us' },
                        }}
                        // className="address-input"
                        apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
                        onPlaceSelected={handleSetAddress}
                        defaultValue={state.address?.address || ''}
                        style={{ borderRadius: 50, border: '0.5px solid grey', width: '100%', paddingBlock: '20px' }}
                      />
                      <p className="address-error">{state.addressError}</p>
                    </Grid>
                    <Button onClick={handleSave} text={t('save')} />
                  </Grid>
                </Grid>
                {isEmpty(selectedRecipient) && (
                  <Grid xs={12} sm={12} md={4} lg={4} container>
                    {!isEmpty(emergencySubscription) ? (
                      <div className="subscriptions-div">
                        <h3>{t('canEmergencySubscription')}</h3>
                        <span className="subscription-fonts">{t('emergencyIncludedInPackage')}</span>
                        <div className="subscription-ending">
                          {t('subscriptionRenewal', {
                            date: moment.unix(emergencySubscription?.lastPayment).add(1, 'month').format('DD/MM/YYYY'),
                          })}
                        </div>
                        {/* <Button variant="contained" className="subscription-button">
                    Upgrade Plan
                  </Button> */}
                      </div>
                    ) : (
                      <div className="subscriptions-div">
                        <h3>{t('canEmergencySubscription')}</h3>
                        <span className="subscription-fonts">{t('notSubscribedEmergency')}</span>
                        <div style={{ marginBottom: '40px' }} />
                        <Button
                          variant="contained"
                          text={t('subscribe')}
                          style={{
                            backgroundColor: '#fff',
                            width: '100%',
                            color: 'black',
                            '&:hover': {
                              background: '#fff',
                              boxShadow: 'none',
                            },
                          }}
                          onClick={() => setPaymentModal(true)}
                        />
                      </div>
                    )}
                  </Grid>
                )}
              </Grid>
            </Grid>
          </div>
          <Modal
            open={paymentMoal}
            onClose={() => setPaymentModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: '10px',
              }}
            >
              <h3>{t('addPayment')}</h3>
              <StripeCardForm
                loading={paymentLoader}
                addPaymentFromDashboard={true}
                isEdit={true}
                editCard={handleSubmitSubscription}
                cancelAddpaymentForm={() => setPaymentModal(false)}
              />
              {paymentError && <p style={{ color: '#3f51b5' }}>{paymentError}</p>}
            </Box>
          </Modal>
          <Modal
            open={otpModal}
            onClose={() => setOtpModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
              }}
            >
              <Typography id="modal-modal-title" variant="h6" component="h2">
                {t('otpSent')}
              </Typography>
              <div style={{ marginTop: '20px' }}>
                <TextInput
                  fullWidth
                  className={classes.deviceInfoInput}
                  type="number"
                  max={6}
                  min={6}
                  value={otp}
                  placeholder={t('enter6DigitOtp')}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (value.length > 6) {
                      return;
                    }
                    setOtp(value);
                  }}
                />
                {otpError && <span style={{ marginTop: '5px', color: 'red' }}>{otpError}</span>}
              </div>
              <div style={{ display: 'flex', marginTop: '20px' }}>
                <Button text={t('cancel')} bg="light" onClick={() => setOtpModal(false)} />
                <Button text={t('verify')} onClick={handleVerifyOtp} style={{ marginLeft: '10px' }} />
              </div>
            </Box>
          </Modal>
          <EmergencyButton />
        </div>
      </div>
    </>
  );
};
export default CanEmergency;
